Ext.define('SA.ProjectViewToolbar', {
    alias: 'widget.project-view-toolbar',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-pvt',
    height: 55,

    items: [
        {
            xtype: 'component',
            cls: 'sa-pvt-sidebar-btn-wrapper',
            height: 55,
            hideMode: 'visibility',
            itemId: 'sidebarBtnWrap',
            margin: '0 22 0 0',
            width: 309,

            html: [
                '<a data-sidebar="locations" class="sa-pvt-sidebar-btn">',
                    '<svg class="sa-pvt-sidebar-btn-icon"><use href="#sa-icon-locations"></use></svg>',
                    'Locations',
                '</a>',
                '<div class="sa-pvt-sidebar-separator"></div>',
                '<a data-sidebar="data" class="sa-pvt-sidebar-btn">',
                    '<svg class="sa-pvt-sidebar-btn-icon"><use href="#sa-icon-data"></use></svg>',
                    'Data',
                '</a>',
                '<div class="sa-pvt-sidebar-separator"></div>',
                '<a data-sidebar="businesses" class="sa-pvt-sidebar-btn">',
                    '<svg class="sa-pvt-sidebar-btn-icon"><use href="#sa-icon-businesses"></use></svg>',
                    'Businesses',
                '</a>'
            ],

            listeners: {
                el: {
                    delegate: '.sa-pvt-sidebar-btn',

                    click(ev, target) {
                        SA.Sidebar.onTabClick(target.getAttribute('data-sidebar'));
                        SA.Sidebar.expand();
                    },

                    mouseout(ev, target) {
                        Ext.fly(target).removeCls('sa-pvt-sidebar-btn-hover');
                    },

                    mouseover(ev, target) {
                        Ext.fly(target).addCls('sa-pvt-sidebar-btn-hover');
                    }
                }
            },

            setEnabledTabs(tabs) {
                var enabled = tab => tabs.includes(tab);

                this.el.down('a[data-sidebar="data"]').ifCls(!enabled('data'), 'sa-pvt-sidebar-btn-disabled');
                this.el.down('a[data-sidebar="locations"]').ifCls(!enabled('locations'), 'sa-pvt-sidebar-btn-disabled');
                this.el.down('a[data-sidebar="businesses"]').ifCls(!enabled('businesses'), 'sa-pvt-sidebar-btn-disabled');
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.sidebarBtnWrap = this.down('#sidebarBtnWrap');

        SA.Viewport.on('resize', () => this.setWidth(Ext.dom.Element.getViewportWidth()));
    },

    clearToolbar() {
        this.setToolbar(null);
    },

    getDropDowns() {
        if (!this.toolbar) {
            return [];
        }

        return this.toolbar.query('combo-button');
    },

    hideTabs() {
        this.sidebarBtnWrap.hide();
    },

    onResize() {
        this.callParent(arguments);

        this.registerDropDownListener();
    },

    registerDropDownListener() {
        if (this.needsDropDownSizing) {
            return;
        }

        this.needsDropDownSizing = true;

        Ext.EventManager.idleEvent.addListener(this.resizeDropDowns, this);
    },

    resizeDropDowns({force = false} = {}) {
        if (!this.needsDropDownSizing && !force) {
            return;
        }

        Ext.EventManager.idleEvent.removeListener(this.resizeDropDowns, this);

        var dropDowns = this.getDropDowns(),
            details;

        dropDowns.forEach(button => {
            button.refreshText();

            button.el.addCls('sa-pvt-measure-width');
        });

        details = dropDowns.map(button => {
            var el = button.el;

            return {
                button,
                el,
                maxWidth: el.getWidth()
            };
        });

        details.forEach(detail => {
            var el = detail.el;

            el.setStyle('max-width', detail.maxWidth + 'px');

            el.removeCls('sa-pvt-measure-width');
        });

        details.forEach(detail => {
            detail.width = detail.el.getWidth();
        });

        details.forEach(detail => {
            if (detail.width < detail.maxWidth) {
                var textEl = detail.el.down('.sa-button-text', true),
                    text = textEl.innerHTML;

                Ext.fly(textEl).setStyle('display', 'flex');

                textEl.innerHTML = '<span class="sa-pvt-truncated-text-left">' + text + '</span><span class="sa-pvt-truncated-text-ellipsis">...</span><span class="sa-pvt-truncated-text-right">' + text + '</span>';
            }

            detail.button.updateLayout();
        });

        this.needsDropDownSizing = false;
    },

    setEnabledTabs(tabs) {
        this.sidebarBtnWrap.setEnabledTabs(tabs);
    },

    setToolbar(toolbar) {
        if (this.toolbar) {
            this.toolbar.hide();
        }

        this.toolbar = toolbar;

        if (!toolbar) {
            return;
        }

        if (!this.items.includes(toolbar)) {
            this.add(toolbar);
        }

        toolbar.show();

        if (!toolbar.didDecorateSetTextMethod) {
            toolbar.didDecorateSetTextMethod = true;

            this.getDropDowns().forEach(button => {
                var setText = button.setText;

                button.setText = text => {
                    setText.call(button, text);

                    this.registerDropDownListener();
                };
            });
        }

        this.needsDropDownSizing = false;

        this.registerDropDownListener();
    },

    showTabs() {
        this.sidebarBtnWrap.show();
    }
});
